<template>
  <new-common-banner
    v-if="installmentInfo && (installmentInfo.indexUrlDesc || installmentInfo.title)"
    title=""
    icon="cdef9ed7-e0c9-484a-a5cf-4b4d7612bc7f.png"
    :showArrow="installmentInfo.indexUrl ? true : false"
    @ensureClick="goToUrl(installmentInfo.indexUrl)"
  >
    <div class="process-item">
      <div class="item_address">
        <span class="title">分期</span>
        <span class="title_info">{{ installmentInfo.indexUrlDesc }}</span>
      </div>
      <div class="item_info">
        <span>{{ installmentInfo.title }}</span>
      </div>
    </div>
  </new-common-banner>
</template>

<script>
import Vue from 'vue'
import { defineComponent, ref, computed } from '@vue/composition-api'
import newCommonBanner from '@/components/new-common-banner.vue'
import { skipToUrl } from '@utils/native'
import { Icon } from '@zz-common/zz-ui'
Vue.use(Icon)
export default defineComponent({
  components: {
    newCommonBanner
  },
  props: {
    installmentInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, ctx) {
    const { $legoSend } = ctx.root
    const foldTxt = ref('收起测算')
    const foldStatus = ref(true)
    const installmentDetails = computed(() => {
      return props.installmentInfo?.installmentDetails?.length
    })
    const foldClick = () => {
      foldStatus.value = !foldStatus.value
      $legoSend('zpmclick', {
        sortId: 0,
        sortName: !foldStatus.value ? '收起测算' : '分期测算'
      })
      ctx.emit('listenFold', foldStatus.value)
    }
    function goToUrl(url) {
      $legoSend('zpmclick', {
        sectionId: 125,
        sortId: 1,
        sortName: '分期信息',
        other: '分期信息'
      })
      url &&
        skipToUrl({
          targetUrl: url
        })
    }
    return {
      goToUrl,
      foldClick,
      foldStatus,
      foldTxt,
      installmentDetails
    }
  }
})
</script>

<style lang="scss" scoped>
.info_tips {
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-size: 18px;
}
.arrowTransform {
  transform: rotateZ(180deg);
  transform-origin: center;
  transition: 0.4s;
}

.arrowTransformReturn {
  transform: rotateZ(-180deg);
  transform-origin: center;
  transition: 0.4s;
}
</style>
